function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(29, 29, 29)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'08b787c84edb1e960d4fc72eeb62bb07': 'rgb(88, 86, 85)','1483fa4f0ec6e94a8a2530a761fa23f0': 'rgb(64, 61, 60)','2aeb970117de1397b70fddf55877d2c8': 'rgb(106, 117, 98)','f24f896aedf2cbf06ae5425ac9c1f07a': 'rgb(189, 153, 96)','a9a818972a843f219939aae97bca4edb': 'rgb(165, 164, 161)','88336b5bb2a1cc21bac7cf33fd451270': 'rgb(201, 190, 159)','2852f697a9f8581725c6fc6a5472a2e5': 'rgb(228, 225, 220)','7dd7e8388a2252448f3e59c75dd4cfe5': 'rgb(68, 52, 27)','42133a3dcbeafd8d1b0a68cae646de2a': 'rgb(113, 111, 108)','b352b8ab0117a50d4804f903e66c5647': 'rgb(141, 168, 203)','e7b95b49658278100801c88833a52522': 'rgb(153, 146, 127)','6c5c1da91145e323a78c062d9c557def': 'rgb(124, 124, 124)','10e8e6020473ffdb9a86bd7c2ed4b884': 'rgb(98, 127, 127)','4de5322b1dba747ee87ac14bd5374849': 'rgb(200, 141, 183)','e4e4b71a4a035f7cd5f579263bcbd549': 'rgb(26, 90, 108)','c08e54d1fb68ddfb473cea49dc085005': 'rgb(223, 66, 47)','190bcfe46d3b5ef1027883806c7d0a66': 'rgb(89, 87, 85)','344a6455f1e897f31d3c3825b00c9f4a': 'rgb(255, 217, 0)','f39b1ab5405e8d9cc2fdb96f6376ad06': 'rgb(143, 138, 136)','54b04493d3bc89472d5e7177219633a1': 'rgb(147, 168, 173)','bb482a9c91cba46c09b57d0e178e171c': 'rgb(212, 214, 214)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
